import {z} from 'zod'

export const AiFormSchema = z.object({
  mensagem: z.string().min(1, 'Mensagem obrigatória'),
})

export type AiFormData = z.infer<typeof AiFormSchema>
